<template>
  <div class="insights-meetings-widget-dialog-details mb-10">
    <template v-if="hasData">
      <div
        v-for="(item, i) in meetings.shares"
        :key="i"
        class="metric"
      >
        <strong>{{ item.value }}%</strong>
        <span>{{ item.label }}</span>

        <div
          v-if="item.time"
          class="time"
        >
          {{ $filters.formatDuration(item.time) }}
        </div>
      </div>
    </template>
    <div v-else>No data available.</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'InsightsMeetingsDialogshares',
  computed: {
    ...mapGetters(['meetings']),
    hasData() {
      return this.meetings.shares?.length;
    },
  },
};
</script>
